<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        name="tbl_partner"
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :show-del="false"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-column-visible="true"
        :show-add="false"
      />
      <PartnerApply
        :id="entityId"
        :action="url"
        :width="450"
        :data="selectedPartner"
        :visible="modalApply"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import PartnerApply from './partner-apply'
import { getLinkTextStyle } from '@/utils/util'
export default {
  name: 'PartnerList',
  components: { TableWrapper, PartnerApply },
  data() {
    return {
      url: this.$config.apiContextPath + '/partner',
      modalForm: false,
      modalApply: false,
      selectedPartner: null,
      entityId: 0,
      types: this.loadPartnerTypes(),
      modCount: 0
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '合伙人姓名', placeholder: '请输入合伙人姓名...', name: 'name', width: 'auto', type: 'input' },
          { label: '合伙人手机', placeholder: '请输入合伙人手机号...', name: 'mobile', width: 'auto', type: 'input' },
          { label: '合伙人角色', placeholder: '请选择合伙人角色...', name: 'type', width: 'auto', type: 'select', options: this.types },
          { label: '审核状态', placeholder: '请选择审核状态...', name: 'status', width: 'auto', type: 'select', options: [
            { label: '待审核', value: 0 },
            { label: '已通过', value: 1 },
            { label: '未通过', value: 2 }
          ] }
        ]
      }
    },
    // mockData() {
    //   return [
    //     {
    //       id: 1, // 表id
    //       memberId: 1, // 用户id
    //       name: '张三', // 用户姓名
    //       mobile: '13612345678', // 用户手机号
    //       // parking: '车库1', // 车库名 (deprecated)
    //       typeName: '授权合伙人', // 合伙人类型
    //       status: 0, // 状态, 0 -> 待审核 , 1 -> 已审核
    //       applyTime: '2020-04-05 22:24', // 申请时间
    //       approveTime: '2020-04-25 23:01' // 审核时间
    //     }
    //   ]
    // },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center', key: '_index', disabled: true },
        { title: '合伙人姓名', align: 'left', key: 'name', sortable: true, ellipsis: true, tooltip: true },
        { title: '合伙人手机', align: 'center', key: 'mobile', sortable: true, ellipsis: true, tooltip: true },
        { title: '合伙人角色', align: 'center', key: 'typeName', sortable: true, ellipsis: true, tooltip: true },
        // { title: '车库', align: 'center', key: 'parking', sortable: true, ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: 'status', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 1 ? 'green' : (params.row.status === 0 ? 'blue' : 'red') }
            }, params.row.status === 0 ? '待审核' : (params.row.status === 1 ? '已通过' : '未通过'))
          }
        },
        { title: '申请理由', align: 'center', sortable: true, key: 'purpose', ellipsis: true, tooltip: true },
        { title: '省份城市', align: 'center', sortable: true, key: 'region', ellipsis: true, tooltip: true },
        { title: '申请时间', align: 'center', sortable: true, key: 'applyTime', ellipsis: true, tooltip: true },
        { title: '审核时间', align: 'center', sortable: true, key: 'approveTime', ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.approveTime || params.row.rejectTime)
          }
        },
        { title: '操作人员', align: 'center', sortable: true, width: 120, key: 'operator', ellipsis: true, tooltip: true },
        // { title: '拒绝时间', align: 'center', sortable: true, key: 'rejectTime', ellipsis: true, tooltip: true },
        { title: '操作', align: 'center', width: 140, key: '_actions', disabled: true, fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: getLinkTextStyle(params.row.status === 0),
                on: {
                  click: () => {
                    if (params.row.id && params.row.status === 0) {
                      // this.changeApproveStatus(params.row.id, params.row, true)
                      this.showApprovalModal(params.row.id, params.row)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-check': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: '审核通过' }}, '通过')
              ]),
              h('a', {
                style: getLinkTextStyle(params.row.status === 0),
                on: {
                  click: () => {
                    if (params.row.id && params.row.status === 0) {
                      this.changeApproveStatus(params.row.id, params.row, false)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-times': true, 'cell-icon-link': true }}),
                h('span', { domProps: { title: '拒绝通过' }}, '拒绝')
              ])
            ])
          }
        }
      ]
    }
  },
  methods: {
    async loadPartnerTypes() {
      await request({
        url: this.$config.apiContextPath + '/partner/type/all',
        method: 'get'
      }).then(res => {
        this.types = []
        const items = res.data
        items.forEach(i => {
          this.types.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.types = []
      })
    },
    showApprovalModal(id, data) {
      this.entityId = id ? parseInt(id) : 0
      this.selectedPartner = data
      this.modalApply = true
    },
    onModalClose(changed) {
      this.entityId = 0
      this.selectedPartner = null
      this.modalForm = false
      this.modalApply = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    changeApproveStatus(id, data, approved) {
      const _this = this
      const _action = approved ? '审核通过' : '拒绝审核'
      const { name, mobile, typeName } = data
      this.$Modal.confirm({
        title: '确认' + _action + name + '用户么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [
            h('li', {}, '会员姓名: ' + name),
            h('li', {}, '会员电话: ' + mobile),
            h('li', {}, '合伙人类型: ' + typeName)
          ])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id + '/approval',
            method: 'POST',
            params: { status: approved ? 1 : 2 }
          }).then(res => {
            this.$Notice.success({ title: '用户' + name + _action + '成功' })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(() => {
            this.$Notice.error({ title: '用户' + name + _action + '失败' })
            _that.buttonLoading = false
          })
        }
      })
    }
  }
}
</script>
